import React from "react";

const Footer = () => {
  return (
    <footer>
      <hr />
      <div className="copyright">
        &copy; 2024 <b>Personal Bookshelf</b>. All rights reserved.
      </div>
      <div className="credit">
        Made with ❤️ by <a href="https://github.com/nitishkumar31">Nitish</a>
      </div>
    </footer>
  );
};

export default Footer;
